/*
 * Preview Carousel V2
 * Version: 1.0.0
 */

ckdc.ready(function ($) {
    if (typeof ckdc == "undefined") {
        return;
    }

    function LatestRecipesCarousel(el) {
        var container = el.querySelector(".dd-recipes-carousel-content");
        var slidesList = container.querySelector("ul");
        var slides = slidesList.querySelectorAll("li");
        var nextEl = el.querySelector(".dd-recipes-carousel-next-btn>div");
        var prevEl = el.querySelector(".dd-recipes-carousel-prev-btn>div");

        var SLIDE_WIDTH = 255;
        var ARROW_BG_WIDTH = 54;
        var totalWidth = SLIDE_WIDTH * slides.length - 1;

        slidesList.style.width = totalWidth + "px";

        var hidePrevElCond = function (px) {
            prevEl.classList.toggle("dd-recipes-hidden", px <= 0);
        };

        var hideNextElCond = function (px) {
            nextEl.classList.toggle(
                "dd-recipes-hidden",
                px >= totalWidth - container.clientWidth
            );
        };

        var onClickOnArrow = function (left) {
            return function () {
                container.scrollBy({left: left, behavior: "smooth"});
            };
        };

        var prevFn = onClickOnArrow(-SLIDE_WIDTH);
        var nextFn = onClickOnArrow(SLIDE_WIDTH);

        slidesList.style.width = totalWidth + "px";

        prevEl.addEventListener("click", prevFn);
        nextEl.addEventListener("click", nextFn);

        hidePrevElCond(0);

        container.addEventListener("scroll", function () {
            var px = container.scrollLeft;

            container.classList.toggle("dd-recipes-x-init", px > 0);
            container.classList.toggle(
                "dd-recipes-x-end",
                px < totalWidth - ARROW_BG_WIDTH
            );

            hidePrevElCond(px);
            hideNextElCond(px);
        });
    }

    document.querySelectorAll(".dd-recipes-carousel").forEach(function (el) {
        var container = el.querySelector(".dd-recipes-carousel-container");
        return new LatestRecipesCarousel(container);
    });
});
